import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { trpc } from 'src/trpc';
import { AddOnForm } from './AddOnForm';
import { AddOn } from 'src/trpc';
import { AddOnFormValues } from '@libs/schemas/src/add-on';
import { useToast } from 'src/components/useToast';

interface EditAddOnModalProps {
  addOn: AddOn | null;
  onClose: () => void;
  onSuccess: () => void;
}

export const EditAddOnModal: React.FC<EditAddOnModalProps> = ({ addOn, onClose, onSuccess }) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const updateAddOnMutation = trpc.admin.addOn.update.useMutation();
  const { successToast, errorToast } = useToast();

  const handleUpdateAddOn = async (values: AddOnFormValues) => {
    if (addOn) {
      try {
        const priceInCents = Math.round(parseFloat(values.priceInCents) * 100);
        await updateAddOnMutation.mutateAsync({
          ...addOn,
          ...values,
          priceInCents: priceInCents.toString(),
        });
        successToast({
          title: 'Add-on Updated',
          description: 'The add-on was successfully updated.',
        });
        onSuccess();
        onClose();
      } catch (error) {
        errorToast({
          title: 'Failed to Update Add-on',
          description: 'There was an error updating the add-on. Please try again.',
        });
      }
    }
  };

  if (!addOn) return null;

  return (
    <AlertDialog open={!!addOn} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-left text-text-light mb-4">
            Edit Add-on
          </AlertDialogTitle>
          <AddOnForm
            initialValues={{
              title: addOn.title,
              description: addOn.description,
              priceInCents: (addOn.priceInCents / 100).toFixed(2),
              archived: addOn.archived,
              customerVisible: addOn.customerVisible ?? true,
            }}
            onSubmit={handleUpdateAddOn}
            isEditing={true}
            onStateChange={({ isValid }) => setIsFormValid(isValid)}
          />
          <div className="flex flex-row justify-end gap-4 pt-4">
            <AlertDialogCancel className="mt-0 text-text-light">Cancel</AlertDialogCancel>
            <Button type="submit" form="add-on-form" className="text-white" disabled={!isFormValid}>
              Update Add-on
            </Button>
          </div>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
};
